import React from "react";
import { Row, Col, Typography } from "antd";

const { Title } = Typography;

const ScoreByDimensionByRelationships = ({ dimension, redLight = 60, yellowLight = 80 }) => {
    if (!dimension || !dimension.average_by_relationship) return null;

    const getColor = (value) => {
        if (value <= redLight) return "#e53935"; // rojo
        if (value <= yellowLight) return "#fbc02d"; // amarillo
        return "#43a047"; // verde
    };

    const getContrastTextColor = (bgColor) =>
        String(bgColor).toLowerCase() === '#fbc02d' ? '#000' : '#fff';

    const boxStyle = (bg) => ({
        backgroundColor: bg,
        width: 80,
        height: 80,
        borderRadius: "8px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        color: getContrastTextColor(bg),
        fontWeight: 600,
        textAlign: "center"
    });

    return (
        <div style={{ width: "100%", padding: "16px 0" }}>
            <Title level={5} style={{ color: "#339C98", marginBottom: 12 }}>
                Puntajes de {dimension.title}
            </Title>

            <Row gutter={[16, 8]} align="middle" wrap={false} style={{ width: "100%", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                {Object.entries(dimension.average_by_relationship).map(([label, value], idx) => (
                    <Col key={idx}>
                        <div style={boxStyle(getColor(value))}>
                            <div style={{ fontSize: 9, textTransform: "uppercase"}}>
                                {label.toUpperCase() === ("AUTOEVALUACIÓN" || "AUTOEVALUACION") ? "Auto evaluación" : label}
                            </div>
                            <div style={{ fontSize: 14 }}>{value.toFixed(1)}</div>
                        </div>
                    </Col>
                ))}

                {/* Promedio sin autoevaluación */}
                <Col>
                    <div style={boxStyle(getColor(dimension.average))}>
                        <div style={{ fontSize: 9, textTransform: "uppercase"}}>
                            Promedio
                        </div>
                        <div style={{ fontSize: 14 }}>{dimension.average.toFixed(1)}</div>
                    </div>
                </Col>
                <Col>
                    <div style={boxStyle(getColor(dimension.another))}>
                        <div style={{ fontSize: 9, textTransform: "uppercase"}}>
                            Promedio sin AE
                        </div>
                        <div style={{ fontSize: 14 }}>{dimension.another.toFixed(1)}</div>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default ScoreByDimensionByRelationships;
